import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../../query/types';

const familiesKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'families'] as const;
  return createQueryKey({
    all: [...key] as const,
    id: <U extends QueryKeyParam>(id: U) =>
      createQueryKey({
        all: [...key, id] as const,
        causes: [...key, id, 'causes'] as const,
      }),
  });
};
export { familiesKeys };
